<template>
  <div class="m-navbar">
    <h1>Navbar</h1>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/navbar/Navbar.vue